<template>
  <div class="order-history">
    <SfTabs :open-tab="1">
      <SfTab :title="$t('Order History')">
        <Loader :loading="isLoading">
          <SfTable v-if="tableRows.length">
            <SfTableHeading>
              <SfTableHeader v-for="header in tableHeaders" :key="header">
                {{ $t(header) }}
              </SfTableHeader>
            </SfTableHeading>
            <SfTableRow v-for="(row, rowIndex) in tableRows" :key="row[0]">
              <SfTableData
                v-for="(data, index) in row"
                :key="`${tableHeaders[index]}-${row[0]}-${data}`"
                :class="status[data]"
              >
                <router-link
                  v-if="tableHeaders[index] === '#'"
                  :to="{ name: 'OrderDetails', params: { id: orders.Orders[rowIndex].Id } }"
                >
                  {{ data }}
                </router-link>
                <span v-else>{{ data }}</span>
              </SfTableData>
            </SfTableRow>
          </SfTable>
          <div v-else>{{ $t('Order history is empty.') }}</div>
        </Loader>
      </SfTab>
      <SfTab
        v-if="config && config.general && config.general.showIncadeaOrders"
        :title="$t('Incadea Order History')"
      >
        <Loader :loading="incadeaIsLoading">
          <SfTable v-if="incadeaTableRows.length">
            <SfTableHeading>
              <SfTableHeader class="row-space" v-for="header in incadeaTableHeaders" :key="header">
                {{ $t(header) }}
              </SfTableHeader>
            </SfTableHeading>
            <SfTableRow v-for="row in incadeaTableRows" :key="row[0]">
              <SfTableData
                class="row-space"
                v-for="(data, index) in row"
                :key="`${tableHeaders[index]}-${row[0]}-${data}`"
                :class="status[data]"
              >
                <span>{{ data }}</span>
              </SfTableData>
            </SfTableRow>
          </SfTable>
          <div v-else>{{ $t('Order history is empty.') }}</div>
        </Loader>
      </SfTab>
    </SfTabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SfTabs, SfTable } from '@storefront-ui/vue';
import { Loader, config } from '@/modules/core';
import user from '../../mixins/user';

export default {
  name: 'OrderHistory',
  mixins: [user, config],
  components: {
    SfTabs,
    SfTable,
    Loader,
  },
  created() {
    this.isLoading = true;
    this.fetchOrders().then(() => {
      this.isLoading = false;
    });

    if (this.config?.general?.showIncadeaOrders) {
      this.incadeaIsLoading = true;
      this.fetchIncadeaOrders().then(() => {
        this.incadeaIsLoading = false;
      });
    }
  },
  data() {
    return {
      isLoading: false,
      incadeaIsLoading: false,
      tableHeaders: [
        this.$t('#'),
        this.$t('Order date'),
        this.$t('Order total'),
        this.$t('Payment status'),
        this.$t('Shipping status'),
        this.$t('Order status'),
      ],
      status: {
        Paid: 'text-success',
        Delivered: 'text-success',
        Complete: 'text-success',
        Pending: 'text-warning',
        'Not yet shipped': 'text-warning',
      },
      incadeaTableHeaders: [
        this.$t('#'),
        this.$t('Document Date'),
        this.$t('Description'),
        this.$t('Due Date'),
        this.$t('Order total'),
        this.$t('Location'),
      ],
    };
  },
  computed: {
    ...mapGetters({
      config: 'core/storeConfig',
    }),
    tableRows() {
      return this.orders.Orders
        ? this.orders.Orders.map((order) => [
          order.OrderNumber,
          this.dateFormatter().format(new Date(order.CreatedOn)),
          this.currencyFormatter().format(order.OrderTotal),
          order.PaymentStatus,
          order.ShippingStatus,
          order.OrderStatus,
        ])
        : [];
    },
    incadeaTableRows() {
      return this.incadeaOrders
        ? this.incadeaOrders.map((order) => [
          order.documentNo,
          this.dateFormatter().format(new Date(order.documentDate)),
          order.description,
          this.dateFormatter().format(new Date(order.dueDate)),
          this.currencyFormatter().format(order.amount),
          order.branchCode,
        ])
        : [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint';

.row-space {
  padding: 0 10px;
}
</style>
